<mat-card class="page-layout fullwidth" fxLayout="column">
    <h3 class="title primary">
        {{ title }} <span>{{ accountNumber }}</span>
    </h3>
    <ng-content></ng-content>
</mat-card>
